import React from 'react';

import { useRefreshRSimInventoryEntry } from '../hooks/useRefreshRSimInventoryEntry';
import { RSimEditDialog } from 'src/rSimInventory/Edit/RSimEditDialog';

export type RSimProductsInventoryEditDialogDialogProps = {
  open: boolean;
  onClose: () => void;
  data: any;
};

export const RSimProductsInventoryEditDialog = React.memo(
  (props: RSimProductsInventoryEditDialogDialogProps) => {
    const { refreshTags } = useRefreshRSimInventoryEntry();

    if (!props.data) {
      return null;
    }

    return <RSimEditDialog {...props} onTagsChange={refreshTags} />;
  },
);
